/**
 * Helper functions for formatting settings values into display text
 */
import { useTranslationsStore } from '@/stores/translations.js'

// Setting value -> i18n key, matching the option labels of the x01 setup form
// (services/games/1_x01.ts) so a summary reads the same as what the host picked.
const VALUE_LABEL_KEYS = {
    win_type: {
        best_of: 'match_settings.best_of',
        first_to: 'match_settings.first_to',
    },
    check_in: {
        single: 'match_settings.straight_in',
        double: 'match_settings.double_in',
        master: 'match_settings.master_in',
    },
    check_out: {
        single: 'match_settings.straight_out',
        double: 'match_settings.double_out',
        master: 'match_settings.master_out',
    },
}

/**
 * Format a setting value into proper display text
 * @param {string} key - The setting key
 * @param {any} value - The setting value
 * @returns {string} - Formatted display text
 */
export function formatSettingValue(key, value) {
    const labelKey = VALUE_LABEL_KEYS[key]?.[value]
    return labelKey ? useTranslationsStore().t(labelKey) : value.toString()
}

/**
 * Get a setting value with proper formatting
 * @param {Object} settings - The settings object
 * @param {string} key - The setting key
 * @returns {string} - Formatted display text
 */
export function getSettingDisplay(settings, key) {
    if (!settings || !settings[key]) {
        return useTranslationsStore().t('general.not_available')
    }
    return formatSettingValue(key, settings[key])
}

/**
 * Format all settings for display
 * @param {Object} settings - The settings object
 * @returns {Object} - Object with formatted values
 */
export function formatAllSettings(settings) {
    if (!settings) return {}

    const formatted = {}
    Object.keys(settings).forEach((key) => {
        formatted[key] = formatSettingValue(key, settings[key])
    })
    return formatted
}
